import * as labelPass from './labelPass';
import * as labelTask from './labelTask';
import * as tasksSeenItems from './tasksSeenItems';
import * as tools from './tools';
export * from './store';

const loadFromCompressedLocalStorage = labelPass.loadFromCompressedLocalStorage;

export { labelPass, labelTask, loadFromCompressedLocalStorage, tasksSeenItems, tools };
